export function untilUtcMidnight(now: number): number {
  const date = new Date(now);
  return Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate() + 1) - now;
}

export function isAdminPath(pathname: string): boolean {
  // React Router matches paths case-insensitively and decodes path segments.
  try { return decodeURIComponent(pathname.split('/')[1] ?? '').split('/')[0].toLowerCase() === 'admin'; }
  catch { return true; }
}
